// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Me","landingPageVideo":"Ne","play":"Oe","iframeVideo":"Pe","playHidden":"Qe","playVisible":"Re","fullwidth":"Se"};